export const DRAGGING = "DRAGGING";
export const RUNNING_STATE = "RUNNING_STATE";
export const SAVE_PROPS = "SAVE_PROPS";
export const DRAGGABLE = "DRAGGABLE";
export const CLONE_MOUNTED = "CLONE_MOUNTED";
export const PAUSED_ON_FULLSCREEN = "PAUSED_ON_FULLSCREEN";
export const SET_DEFAULT_MESSAGE = "SET_DEFAULT_MESSAGE";
export const CHANGE_MESSAGE = "CHANGE_MESSAGE";
export const CLOSE_MESSAGE = "CLOSE_MESSAGE";
